module.exports = __webpack_public_path__ + "ui-icons_222222_256x240.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-icons_222222_256x240.png
// module id = 809
// module chunks = 1